var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-home-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85563 12.8517L12.0001 2.59916L22.1446 12.8512C22.2421 12.9502 22.3711 12.9997 22.5001 12.9997C22.6271 12.9997 22.7546 12.9517 22.8516 12.8552C23.0481 12.6607 23.0496 12.3447 22.8556 12.1482L12.3556 1.53666C12.1681 1.34716 11.8321 1.34716 11.6446 1.53666L1.14463 12.1482C0.950134 12.3447 0.952134 12.6607 1.14863 12.8552C1.34413 13.0497 1.66163 13.0472 1.85563 12.8517Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 23H20.5C20.7765 23 21 22.776 21 22.5V13C21 12.724 20.7765 12.5 20.5 12.5C20.2235 12.5 20 12.724 20 13V22H14V16.5C14 16.224 13.7765 16 13.5 16H10.5C10.2235 16 10 16.224 10 16.5V22H4V13C4 12.724 3.7765 12.5 3.5 12.5C3.2235 12.5 3 12.724 3 13V22.5C3 22.776 3.2235 23 3.5 23H10.5C10.7765 23 11 22.776 11 22.5V17H13V22.5C13 22.776 13.2235 23 13.5 23Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-home-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.37904b3e270edf92a08d2e08f4c525ac.svg";
export { ForwardRef as ReactComponent };